import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { CampaignRow } from '../outreachTypes';
import { inboxMessages as messages } from './inboxMessages';

interface InboxCampaignPickerProps {
  accountId: number;
  value: string | null;
  onChange: (campaignUuid: string | null) => void;
}

/** "Campaign: All" (design outreach g1 head): the replies of one campaign. */
const InboxCampaignPickerComponent: React.FC<InboxCampaignPickerProps> = ({ accountId, value, onChange }) => {
  const intl = useIntl();
  const trpcAPI = useTRPCAPI();
  const { data } = useTRPCQuery(trpcAPI.outreach.campaigns.list.queryOptions({ accountId }, { retry: false }));
  const options = useMemo(
    () =>
      ((data as CampaignRow[] | undefined) ?? []).map((row) => (
        <option key={row.campaignUuid} value={row.campaignUuid}>
          {row.name}
        </option>
      )),
    [data]
  );
  return (
    <select
      className="form-select form-select-sm w-auto"
      aria-label={intl.formatMessage(messages.campaign)}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
    >
      <option value="">{intl.formatMessage(messages.allCampaigns)}</option>
      {options}
    </select>
  );
};

export const InboxCampaignPicker = TypedMemo(InboxCampaignPickerComponent);
